import { getChannelByTheme } from '@tujia/fe-css/lib/jsUtil/themeHelper';
import create from '../utils/create-basic';
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "loading-wrapper"
    }, [_c('div', {
      staticClass: "loading-logo"
    }, [_c('img', {
      staticClass: "ctrip-logo",
      attrs: {
        "src": _vm.logoUrlCpd
      }
    })]), _vm._m(0)]);
  },
  staticRenderFns: [function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "circular-list"
    }, [_c('div', {
      staticClass: "circular circular1"
    }), _c('div', {
      staticClass: "circular circular2"
    }), _c('div', {
      staticClass: "circular circular3"
    })]);
  }],
  name: 'ctripMayiLoading',
  computed: {
    logoUrlCpd: function logoUrlCpd() {
      if (getChannelByTheme() === 'ctrip') {
        return 'https://pic.tujia.com/upload/festatic/mp/ctriplogo.png';
      } else if (getChannelByTheme() === 'mayi') {
        return 'https://pic.tujia.com/upload/festatic/mp/loading_my.png';
      }
    }
  }
});